// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportPage_container__3SVO7"};